import PropTypes from 'prop-types';

import { Tag as BasicTag } from 'basic-components';

const Tag = ({ onClear, tagKey, value }) => (
  <BasicTag
      key={tagKey}
      onClear={onClear}
  >
    <div className="data-science__pipeline-creator__body__options__resolver__bottom-row__symbol-filter__row__tag__key">
      {tagKey}:
    </div>
    <div className="data-science__pipeline-creator__body__options__resolver__bottom-row__symbol-filter__row__tag__value">
      {typeof value === "string" ? value : value.join(",")}
    </div>
    <div className="data-science__pipeline-creator__body__options__resolver__bottom-row__symbol-filter__row__tag__metadata">
      Metadata
    </div>
  </BasicTag>
)

Tag.propTypes = {
  onClear: PropTypes.func.isRequired,
  tagKey: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array
  ]).isRequired,
}

export default Tag